export const assetCondition = {
    CONDITION_POOR: 'Poor',
    CONDITION_TOLERABLE: 'Tolerable',
    CONDITION_ALARM: 'Alarm',
    CONDITION_ALERT: 'Alert',
    CONDITION_GOOD: 'Good',
    CONDITION_UNKNOWN: 'Unknown',
    CONDITION_UNSUPPORTED: 'Unsupported',
};


export const actionTypes = {
    ACTIVE_SUB_DATA: 'powertrainTools/subscriptionStatus/ACTIVE_SUB_DATA',
    GET_ASSET_NEWCAPABILITIES: 'powertrainAssetDetails/GET_ASSET_NEWCAPABILITY',
    GET_ASSET_OVERVIEW: 'detailedInformation/GET_ASSET_OVERVIEW',
    LOAD_ASSET_LABELS: 'assetLabels/LOAD_ASSET_LABELS',
    GET_DRIVE_EVENTS_SUMMARY: 'driveEvents/GET_DRIVE_EVENTS_SUMMARY',
    GET_SMART_CONDITION_SUMMARY: 'smartCondition/GET_SMART_CONDITION_SUMMARY'
};

export const assetOnlineStatus = {
    ONLINE: 'Online',
    OFFLINE: 'Offline'
};

export const conditionIndices = {
    THRESHOLD: 'threshold',
    TREND: 'trend'
};

export const MAX_WORDS = 20;
export const MAX_TAGS = 3;
export const maxAnomalyLevel = 5;


